import React from 'react';
import Leaderboard from '../components/Leaderboard/Leaderboard';
import './LeaderboardPage.css';

const LeaderboardPage = () => {
  return (
    <div className="leaderboard-page-container">
      <Leaderboard />
    </div>
  );
};

export default LeaderboardPage;
